import { Helmet } from "react-helmet";
import SavingSection from "./components/SavingSection";
import { useEffect } from "react";

const Homepage = () => {
    useEffect(() => {
        window.digitalData.page.pageInfo.pageName = "Homepage"
    }, [])
    return (
        <>
            <SavingSection />
        </>
    )
}

export default Homepage